import { loaderAction, paymentFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const getPaymentByIdThunk = (args) => async (dispatch, getState) => {
    const { user, debt_list } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.id);

        const response = await api({ data: formData, link: 'get_payment_by_id' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если открыт список долгов, меняем дату платежа в форме на текущую
            if (debt_list.open) {
                response.payment.date = new Date().toLocaleDateString('fr-CA');
            }
            dispatch(paymentFormAction(response.payment));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }

};